import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { getSportIdBySlug } from '~shared/utils/sportsbook';
import { seoUrlInplaySport } from '~spa/Utils/SeoUrls';
import { useInplayCounterService } from './service';
import { Link } from '~spa/Components/Link/Link';

import './styles/_bet-inplay-btn.scss';

const InplayEventsCounterButton = ({
    sportSlug,
    localizedSportSlug,
}) => {

    const sportId = getSportIdBySlug(sportSlug);

    const inplayCount = useInplayCounterService(sportSlug);
    const inplaySportUrl = seoUrlInplaySport(localizedSportSlug, sportId);

    return (
        inplayCount
        ? <h4
            className="bet-inplay-btn-wrapper"
            data-slug={sportSlug}
        >
            <Link
                to={inplaySportUrl}
                className="bet-inplay-btn"
                gtmAttribute={`${sportSlug};inplay-widget;see-all`}
            >
                <div
                    className={`sport-icon bb-icon--${sportSlug}`}
                ></div>
                <Trans
                    i18nKey="inplay.events_count"
                    count={inplayCount}>
                        <span className="num-inplay-events">{inplayCount}</span> <span className="live-highlight">Live</span> Match
                </Trans>
            </Link>
        </h4>
        : null
    );
};

InplayEventsCounterButton.propTypes = {
    sportSlug: PropTypes.string.isRequired,
    localizedSportSlug: PropTypes.string.isRequired,
};

export default InplayEventsCounterButton;
